export const ENTITY_MULTI_VALUE_ICON_SIZE = 32
